import { render, staticRenderFns } from "./Combinar.vue?vue&type=template&id=b2e1533e"
import script from "./Combinar.vue?vue&type=script&lang=js"
export * from "./Combinar.vue?vue&type=script&lang=js"
import style0 from "./Combinar.vue?vue&type=style&index=0&id=b2e1533e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports